import { Car } from "./car";
import { Customer } from "./customer";
import { Dealer } from "./dealer";
import { Tyre } from "./tyre";
import { ServiceAddon } from "./serviceaddon";

export class IAgreement {
  _id: string;
  customer: string;
  car: Array<Car> | Car;
  years: string;
  km: string;
  addons: Array<ServiceAddon>;
  service_price: number;
  contract_date?: string;
  price: number;
  customerAccept: boolean;
  pdf: string;
  status: boolean;
  dealer_id: string;
  sellerInitials: string;
  final_amount: number;
  calculatorType: string;
  carMonthsOld: number;
  monthsToGo: number;
  regnr: String;
  department?: String;
}

export class Agreement extends IAgreement {
  specialOffer: boolean;
  payout: number;
  //for rendering only
  tyre: Tyre;
}



// WEBPACK FOOTER //
// ./src/app/_models/agreement.ts